<div
    class="map"
    leaflet
    [leafletOptions]="mapOptions"
    [leafletLayers]="layers"
    [leafletFitBounds]="bounds"
    [leafletFitBoundsOptions]="boundsOptions"
    [leafletLayersControl]="layersControl"
></div>
<div class="show-disabled-devices">
    <input type="checkbox" [(ngModel)]="showDisabledDevices" (change)="onShowDisabledDevicesChange()" />
    {{ "MAP.ShowDisabledDevices" | translate }}
</div>
